"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaVolumeSlider = exports.VOLUME_SLIDER_WIDTH = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var remotion_1 = require("remotion");

var icons_1 = require("./icons");

var use_hover_state_1 = require("./use-hover-state");

var BAR_HEIGHT = 5;
var KNOB_SIZE = 12;
exports.VOLUME_SLIDER_WIDTH = 100;

var MediaVolumeSlider = function MediaVolumeSlider(_ref) {
  var displayVerticalVolumeSlider = _ref.displayVerticalVolumeSlider;

  var _remotion_1$Internals = remotion_1.Internals.useMediaMutedState(),
      _remotion_1$Internals2 = _slicedToArray(_remotion_1$Internals, 2),
      mediaMuted = _remotion_1$Internals2[0],
      setMediaMuted = _remotion_1$Internals2[1];

  var _remotion_1$Internals3 = remotion_1.Internals.useMediaVolumeState(),
      _remotion_1$Internals4 = _slicedToArray(_remotion_1$Internals3, 2),
      mediaVolume = _remotion_1$Internals4[0],
      setMediaVolume = _remotion_1$Internals4[1];

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      focused = _ref3[0],
      setFocused = _ref3[1];

  var parentDivRef = (0, react_1.useRef)(null);
  var inputRef = (0, react_1.useRef)(null);
  var hover = (0, use_hover_state_1.useHoverState)(parentDivRef); // eslint-disable-next-line react-hooks/rules-of-hooks

  var randomId = typeof react_1.useId === 'undefined' ? 'volume-slider' : (0, react_1.useId)();

  var _ref4 = (0, react_1.useState)(function () {
    return "__remotion-volume-slider-".concat((0, remotion_1.random)(randomId)).replace('.', '');
  }),
      _ref5 = _slicedToArray(_ref4, 1),
      randomClass = _ref5[0];

  var isMutedOrZero = mediaMuted || mediaVolume === 0;

  var onVolumeChange = function onVolumeChange(e) {
    setMediaVolume(parseFloat(e.target.value));
  };

  var onBlur = function onBlur() {
    setTimeout(function () {
      // We need a small delay to check which element was focused next,
      // and if it wasn't the volume slider, we hide it
      if (document.activeElement !== inputRef.current) {
        setFocused(false);
      }
    }, 10);
  };

  var onClick = (0, react_1.useCallback)(function () {
    if (mediaVolume === 0) {
      setMediaVolume(1);
      setMediaMuted(false);
      return;
    }

    setMediaMuted(function (mute) {
      return !mute;
    });
  }, [mediaVolume, setMediaMuted, setMediaVolume]);
  var parentDivStyle = (0, react_1.useMemo)(function () {
    return _objectSpread({
      display: 'inline-flex',
      background: 'none',
      border: 'none',
      padding: '6px',
      justifyContent: 'center',
      alignItems: 'center',
      touchAction: 'none'
    }, displayVerticalVolumeSlider && {
      position: 'relative'
    });
  }, [displayVerticalVolumeSlider]);
  var volumeContainer = (0, react_1.useMemo)(function () {
    return {
      display: 'inline',
      width: icons_1.ICON_SIZE,
      height: icons_1.ICON_SIZE,
      cursor: 'pointer',
      appearance: 'none',
      background: 'none',
      border: 'none',
      padding: 0
    };
  }, []);
  var inputStyle = (0, react_1.useMemo)(function () {
    var commonStyle = {
      WebkitAppearance: 'none',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      borderRadius: BAR_HEIGHT / 2,
      cursor: 'pointer',
      height: BAR_HEIGHT,
      width: exports.VOLUME_SLIDER_WIDTH
    };

    if (displayVerticalVolumeSlider) {
      return _objectSpread(_objectSpread({}, commonStyle), {}, {
        transform: "rotate(-90deg)",
        position: 'absolute',
        bottom: icons_1.ICON_SIZE + exports.VOLUME_SLIDER_WIDTH / 2 + 5
      });
    }

    return _objectSpread(_objectSpread({}, commonStyle), {}, {
      marginLeft: 5
    });
  }, [displayVerticalVolumeSlider]);
  var sliderStyle = "\n\t.".concat(randomClass, "::-webkit-slider-thumb {\n\t\t-webkit-appearance: none;\n\t\tbackground-color: white;\n\t\tborder-radius: ").concat(KNOB_SIZE / 2, "px;\n\t\tbox-shadow: 0 0 2px black;\n\t\theight: ").concat(KNOB_SIZE, "px;\n\t\twidth: ").concat(KNOB_SIZE, "px;\n\t}\n\t.").concat(randomClass, " {\n\t\tbackground-image: linear-gradient(\n\t\t\tto right,\n\t\t\twhite ").concat(mediaVolume * 100, "%, rgba(255, 255, 255, 0) ").concat(mediaVolume * 100, "%\n\t\t);\n\t}\n\n\t.").concat(randomClass, "::-moz-range-thumb {\n\t\t-webkit-appearance: none;\n\t\tbackground-color: white;\n\t\tborder-radius: ").concat(KNOB_SIZE / 2, "px;\n\t\tbox-shadow: 0 0 2px black;\n\t\theight: ").concat(KNOB_SIZE, "px;\n\t\twidth: ").concat(KNOB_SIZE, "px;\n\t}\n");
  return (0, jsx_runtime_1.jsxs)("div", {
    ref: parentDivRef,
    style: parentDivStyle,
    children: [(0, jsx_runtime_1.jsx)("style", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: sliderStyle
      }
    }), (0, jsx_runtime_1.jsx)("button", {
      "aria-label": isMutedOrZero ? 'Unmute sound' : 'Mute sound',
      title: isMutedOrZero ? 'Unmute sound' : 'Mute sound',
      onClick: onClick,
      onBlur: onBlur,
      onFocus: function onFocus() {
        return setFocused(true);
      },
      style: volumeContainer,
      type: "button",
      children: isMutedOrZero ? (0, jsx_runtime_1.jsx)(icons_1.VolumeOffIcon, {}) : (0, jsx_runtime_1.jsx)(icons_1.VolumeOnIcon, {})
    }), (focused || hover) && !mediaMuted ? (0, jsx_runtime_1.jsx)("input", {
      ref: inputRef,
      "aria-label": "Change volume",
      className: randomClass,
      max: 1,
      min: 0,
      onBlur: function onBlur() {
        return setFocused(false);
      },
      onChange: onVolumeChange,
      step: 0.01,
      type: "range",
      value: mediaVolume,
      style: inputStyle
    }) : null]
  });
};

exports.MediaVolumeSlider = MediaVolumeSlider;